import {
  Alert,
  ButtonLink,
  PrimaryButton,
  SecondaryButton,
} from '@designsforhealth/dfh-react-components'
import { Grid } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import styled, { css } from 'styled-components'

import { StyledSmallHeader } from '../dashboard/styled'

export const StyledHeader = styled.header`
  margin-bottom: 39px;
`

export const StyledAddPromoHeader = styled(StyledSmallHeader)``

export const StyledColumnHeader = styled(StyledSmallHeader)`
  margin-bottom: -10px;
`

export const StyledColumnHeaderLink = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.component.link};
  font-size: 14px;
  text-decoration: underline;
  width: 100%;
  margin-top: 36px;
  text-align: end;
`

export const StyledPrimaryButton = styled(PrimaryButton)`
  width: 100%;
`

export const StyledButtonLink = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.component.link};
  width: 100%;
  text-align: center;
  align-items: center;
  text-decoration: underline;
`

export const StyledSecondaryButton = styled(SecondaryButton)`
  width: 100%;
  border: ${(props) => `1px solid ${props.theme.colors.brand.orange}`};
  color: ${(props) => props.theme.colors.brand.orange};
`

export const StyledDeleteButton = styled(StyledSecondaryButton)`
  width: unset;
`

const commonRowColor = css`
  background-color: white;
  &.inactive {
    color: ${({ theme }) => theme.colors.coolGray.cool600};
    background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  }
`

const commonRowHeight = css`
  height: 40px;
  &.expirationDate {
    height: 60px;
  }
`

export const StyledPromoRowDetail = styled.div`
  ${commonRowColor};
  ${commonRowHeight};
  padding-top: 10px;
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledExpirationDate = styled.div`
  font-size: 14px;
  font-style: italic;
  color: ${({ theme }) => theme.colors.coolGray.cool600};
`

export const StyledIconContainer = styled.div`
  ${commonRowColor};
  ${commonRowHeight};
  width: 100%;
  padding-right: 5px;
`

export const StyledCopyIcon = styled.img`
  ${commonRowColor};
  height: 35px;
  width: 30px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 5px;
`

export const StyledExpandIcon = styled(ExpandMoreIcon)`
  ${commonRowColor};
  width: 30px;
  height: 40px;
  color: ${({ theme }) => theme.colors.coolGray.cool600};
  float: right;
`

export const StyledCloseIcon = styled(StyledExpandIcon)`
  transform: rotate(180deg);
`

export const StyledFieldContainer = styled.div`
  .MuiFormControl-root {
    margin-bottom: 0;
  }
`

export const StyledDropdownGrid = styled(Grid)`
  padding-left: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool400};
`

export const StyledAlert = styled(Alert)`
  margin-bottom: -20px;
`
